export function normalizeLoginFieldErrors(
    errors: Record<string, string[]>
): Record<string, string> {
    return Object.fromEntries(
        Object.entries(errors).map(([key, messages]) => [
            key === 'identifier' ? 'email' : key,
            messages[0],
        ])
    );
}
